export default "__VITE_IMAGE_ASSET__ff95b88f__";